/* start - flights_web_remove_baggage_weight_size_fd */
import { UIIncludedProductBySegmentCompressed } from "@flights/types";

// Compresses baggages if the type is the same for all segments,
// disregarding differences in weight and size.
export function compressSameTypeBaggage(includedProducts: UIIncludedProductBySegmentCompressed | undefined) {
  if (!includedProducts) {
    return undefined;
  }

  const firstSegmentAllowance = includedProducts?.segments?.[0]?.map((item) => item.luggageType);
  const hasSameAllowance = includedProducts?.segments.every((segment) => {
    if (segment.length === firstSegmentAllowance.length) {
      return segment.every((item, index) => item.luggageType === firstSegmentAllowance[index]);
    }

    return false;
  });

  if (hasSameAllowance) {
    return {
      segments: includedProducts.segments.slice(0, 1),
      areAllSegmentsIdentical: true
    };
  } else {
    return includedProducts;
  }
}
/* end - flights_web_remove_baggage_weight_size_fd */
